import React from 'react';

export default class ProgramForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {value: this.props.progNames[0]};

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        this.props.handleSelect();
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.callbackParent(this.state.value)
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <label className="Prog-form">
                    Pick a program to run:
                <br />
                    <select value={this.state.value} onChange={this.handleChange}>
                        {this.props.progNames.map((val, i) => (
                            <option key={i} value={val}>{val}</option>
                        ))}
                    </select>
                </label>
                <br />
                <input type="submit" value="Run" className="Run-Button"/>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ProgramForm.js